const {ALIGNMENT_LE} = require('./../../../../aligmentList')
const {baneFollowerList} = require('./../../../../textCommonParts')
const {CONDITION_FRIGHTENED} = require('./../../../../conditionList')
const {CR_6} = require('./../../../../crList')
const {CREATURE_BLACK_GAUNTLET_OF_BANE} = require('./../../../../creatureIdList')
const {DAMAGE_NECROTIC} = require('./../../../../damageTypeList')
const {GENDER_FEMALE} = require('./../../../../genderList')
const {LANG_COMMON} = require('./../../../../languageIdList')
const {PC_CLASS_CLERIC} = require('./../../../../pcClassIdList')
const {PROF_NORMAL} = require('./../../../../proficiencyList')
const {SIZE_MEDIUM} = require('./../../../../sizeList')
const {SOURCE_BGDIA} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')
const {
  CREATURE_TYPE_HUMAN,
  CREATURE_TYPE_HUMANOID,
} = require('./../../../../creatureTypeIdList')
const {
  SKILL_INTIMIDATION,
  SKILL_PERCEPTION,
} = require('./../../../../skillList')
const {
  GEAR_CHAIN_MAIL,
  GEAR_MACE,
} = require('./../../../../gearIdList')
const {
  SPELL_BANE,
  SPELL_BLESS,
  SPELL_CURE_WOUNDS,
  SPELL_GUIDANCE,
  SPELL_GUIDING_BOLT,
  SPELL_SACRED_FLAME,
  SPELL_SENDING,
  SPELL_SPIRIT_GUARDIANS,
  SPELL_THAUMATURGY,
} = require('./../../../../spellIdList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  ABILITY_AURA_OF_TERROR,
  ABILITY_TACTICAL_DISCIPLINE,
} = require('./../../../../creatureAbilityList')

module.exports = {
  name: 'Чёрная перчатка Бэйна',
  nameAlt: 'Чёрная рукавица Бэйна',
  nameEn: 'Black Gauntlet of Bane',
  id: CREATURE_BLACK_GAUNTLET_OF_BANE,
  description: baneFollowerList,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_HUMAN,
    CREATURE_TYPE_HUMANOID,
  ],
  alignmentId: ALIGNMENT_LE,
  source: {
    id: SOURCE_BGDIA,
    page: 236,
  },
  armor: {
    ac: 16,
    gearId: GEAR_CHAIN_MAIL,
  },
  hp: {
    diceCount: 6,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 18,
    [PARAM_DEX]: 11,
    [PARAM_CON]: 18,
    [PARAM_INT]: 12,
    [PARAM_WIT]: 15,
    [PARAM_CHA]: 18,
  },
  saveThrowList: [
    PARAM_WIT,
  ],
  skillCollection: {
    [SKILL_INTIMIDATION]: PROF_NORMAL,
    [SKILL_PERCEPTION]: PROF_NORMAL,
  },
  immunityConditionList: [
    CONDITION_FRIGHTENED,
  ],
  languageList: [
    LANG_COMMON,
  ],
  cr: CR_6,
  featureList: [
    ABILITY_AURA_OF_TERROR,
    ABILITY_TACTICAL_DISCIPLINE,
  ],
  spellCast: {
    spellCasterLevel: 5,
    spellCasterClass: PC_CLASS_CLERIC,
    spellIdList: [
      SPELL_BANE,
      SPELL_BLESS,
      SPELL_CURE_WOUNDS,
      SPELL_GUIDANCE,
      SPELL_GUIDING_BOLT,
      SPELL_SACRED_FLAME,
      SPELL_SENDING,
      SPELL_SPIRIT_GUARDIANS,
      SPELL_THAUMATURGY,
    ],
    slotCountList: [
      Infinity,
      4,
      3,
      2,
    ],
  },
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает две атаки _Булавой_.`,
    },
    {
      gearId: GEAR_MACE,
      attack: {
        hit: {
          type: DAMAGE_NECROTIC,
          diceCount: 3,
          diceType: 8,
        },
      },
    },
  ],
  genderId: GENDER_FEMALE,
}
